import { apiFetch } from "../client"

export async function listTickets(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/tickets${query}`)
}

export async function getTicket(ticketId: string) {
  return apiFetch<any>(`/tickets/${ticketId}`)
}

export async function createTicket(body: Record<string, unknown>) {
  return apiFetch<any>("/tickets", { method: "POST", rawBody: body })
}

export async function updateTicket(ticketId: string, body: Record<string, unknown>) {
  return apiFetch<any>(`/tickets/${ticketId}`, { method: "PATCH", rawBody: body })
}

export async function addTicketMessage(ticketId: string, body: Record<string, unknown>) {
  return apiFetch<any>(`/tickets/${ticketId}/messages`, { method: "POST", rawBody: body })
}

export async function escalateTicket(ticketId: string, body: Record<string, unknown>) {
  return apiFetch<any>(`/tickets/${ticketId}/escalate`, { method: "POST", rawBody: body })
}
